// @flow
import React from 'react';
import ReactDOM from 'react-dom';

import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

// import './index.css'; // For development only
import './material-ui.css';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { configs, color, products } from './constants';
// import * as serviceWorker from './serviceWorker';

import App from './App';

const theme = createMuiTheme({
  palette: {
    primary: {
      light: color.beige,
      main: color.beige,
      dark: color.beige,
    },
  },
  typography: {
    useNextVariants: true,
    // Dev should have this on their machine. Exists in module parent project.
    fontFamily: '"Scto Grotesk A", Arial, sans-serif',
  },
});

const root = document.getElementById('module-configurator-root');

// Read the accordion/form HTML before React mounts so it lands in the
// initial state rather than being set via componentDidMount setState,
// which suffers from batching issues in React 16.
const quoteEl = document.getElementById('module-configurator-quote');
const initialAccordionHTML = quoteEl ? quoteEl.innerHTML : '';
if (quoteEl) quoteEl.parentNode.removeChild(quoteEl);

if (root instanceof Element) {
  ReactDOM.render(
    <MuiThemeProvider theme={theme}>
      <App
        products={products}
        configs={configs}
        defaultProduct={root.getAttribute('data-product')}
        initialAccordionHTML={initialAccordionHTML}
      />
    </MuiThemeProvider>,
    root
  );
}
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
// serviceWorker.unregister();
